import type { GalleryItem, LinkItem } from "./types";
import type { SiteLocale } from "./locales";
import { localizedCopy } from "./locales";

const value = (name: string) => import.meta.env[name] as string | undefined;
const mail = value("VITE_CONTACT_EMAIL");
export const siteConfig = {
  name: "Daniel Montana",
  descriptor: "Model · Content Creator",
  siteUrl: value("VITE_SITE_URL"),
  exclusiveUrl: value("VITE_EXCLUSIVE_URL"),
  telegramUrl: (locale: SiteLocale) => withTelegramGreeting(
    value("VITE_TELEGRAM_URL"),
    locale === "es" ? value("VITE_TELEGRAM_GREETING") ?? localizedCopy.es.telegramGreeting : localizedCopy.en.telegramGreeting,
  ),
  instagramUrl: value("VITE_INSTAGRAM_URL"),
  xUrl: value("VITE_X_URL"),
  facebookUrl: value("VITE_FACEBOOK_URL"),
  threadsUrl: value("VITE_THREADS_URL"),
  telegramFreeUrl: value("VITE_TELEGRAM_FREE_URL"),
  contactEmail: mail,
};

function withTelegramGreeting(rawUrl: string | undefined, greeting: string) {
  if (!rawUrl) return undefined;
  try {
    const url = new URL(rawUrl);
    const isTelegram =
      /(^|\.)t\.me$/i.test(url.hostname) ||
      /(^|\.)telegram\.me$/i.test(url.hostname);
    const path = url.pathname.replace(/^\/+|\/+$/g, "");
    const supportsDraft =
      isTelegram &&
      path &&
      !path.startsWith("+") &&
      !path.startsWith("joinchat/");
    if (supportsDraft) {
      url.searchParams.set("text", greeting);
      // Telegram drafts need percent-encoded spaces instead of form-style "+".
      url.search = url.searchParams.toString().replace(/\+/g, "%20");
    }
    return url.toString();
  } catch {
    return rawUrl;
  }
}

export const missingRequiredLinks = [
  ["VITE_EXCLUSIVE_URL", siteConfig.exclusiveUrl],
  ["VITE_TELEGRAM_URL", value("VITE_TELEGRAM_URL")],
  ["VITE_INSTAGRAM_URL", siteConfig.instagramUrl],
  ["VITE_X_URL", siteConfig.xUrl],
  ["VITE_CONTACT_EMAIL", siteConfig.contactEmail],
]
  .filter(([, url]) => !url)
  .map(([key]) => key);

/* Categories: Portrait, Fitness, Lifestyle, Editorial
  Portrait: Daniel es el foco principal; primer plano o medio cuerpo, mirada, expresión, rostro o pose. El entorno importa poco.
  Fitness: La actividad física es el tema: gimnasio, entrenamiento, rutina, equipo, ropa deportiva o físico en contexto deportivo.
  Lifestyle: Momentos cotidianos y contexto personal: ciudad, viaje, casa, café, salida, amigos, look casual o escenas fuera de sesión.
  Editorial: Foto producida con intención estética/de moda: iluminación cuidada, styling, dirección de arte, pose más conceptual o sesión profesional.
Ratios: portrait, landscape, square
Tones: wine, sand, smoke, olive
Ratings: public, restricted */
export const galleryItems: GalleryItem[] = [
  {
    id: "01",
    label: "Galería 01",
    alt: "Daniel Montana en una fotografía de galería",
    src: "/gallery/FFB6CBB8-5CBA-4127-A3CF-C8B4C6EDC0B3.jpeg",
    category: "Fitness",
    ratio: "portrait",
    tone: "wine",
    rating: "public",
  },
  {
    id: "02",
    label: "Galería 02",
    alt: "Daniel Montana en una fotografía de galería",
    src: "/gallery/804B04C4-3793-4D02-B6D1-69EDEDF92D17.jpeg",
    category: "Portrait",
    ratio: "portrait",
    tone: "smoke",
    rating: "public",
  },
  {
    id: "03",
    label: "Galería 03",
    alt: "Daniel Montana en una fotografía de galería",
    src: "/gallery/879B4978-CBAE-4031-ACB3-853C1A700A58.jpeg",
    category: "Fitness",
    ratio: "portrait",
    tone: "sand",
    rating: "public",
  },
  {
    id: "04",
    label: "Galería 04",
    alt: "Daniel Montana en una fotografía de galería",
    src: "/gallery/3A2E7614-B053-45BF-B27D-7CF66574E027.jpeg",
    category: "Lifestyle",
    ratio: "portrait",
    tone: "olive",
    rating: "public",
  },
  {
    id: "05",
    label: "Galería 05",
    alt: "Daniel Montana en una fotografía de galería",
    src: "/gallery/68F3741F-BAD7-4358-B9DB-4195C49A4121.jpeg",
    category: "Lifestyle",
    ratio: "portrait",
    tone: "wine",
    rating: "public",
  },
  {
    id: "06",
    label: "Galería 06",
    alt: "Daniel Montana en una fotografía de galería",
    src: "/gallery/8C231165-73DD-4C25-B004-C85EFE67AE74.jpeg",
    category: "Lifestyle",
    ratio: "portrait",
    tone: "smoke",
    rating: "public",
  },
  {
    id: "07",
    label: "Galería 07",
    alt: "Daniel Montana en una fotografía de galería",
    src: "/gallery/AEBCB6DE-D484-40A2-B714-E1A5D2A99456.jpeg",
    category: "Lifestyle",
    ratio: "square",
    tone: "sand",
    rating: "public",
  },
  {
    id: "08",
    label: "Galería 08",
    alt: "Daniel Montana en una fotografía de galería",
    src: "/gallery/F14B7859-C45D-4A46-9E08-06B33DF62658.jpeg",
    category: "Lifestyle",
    ratio: "portrait",
    tone: "olive",
    rating: "public",
  },
  {
    id: "09",
    label: "Galería 09",
    alt: "Daniel Montana en una fotografía de galería",
    src: "/gallery/9F914B14-A508-4A8D-BAEF-A344AF7F932D.jpeg",
    category: "Portrait",
    ratio: "portrait",
    tone: "wine",
    rating: "public",
  },
  {
    id: "10",
    label: "Galería 10",
    alt: "Daniel Montana en una fotografía de galería",
    src: "/gallery/C61325CB-1AEF-48E5-ACB6-9A2C59514A5B.jpeg",
    category: "Portrait",
    ratio: "portrait",
    tone: "smoke",
    rating: "public",
  },
  {
    id: "11",
    label: "Galería 11",
    alt: "Daniel Montana en una fotografía de galería",
    src: "/gallery/6ECB7235-6CFC-466D-9EA5-36FC9B50829E.jpeg",
    category: "Lifestyle",
    ratio: "portrait",
    tone: "sand",
    rating: "public",
  },
  {
    id: "12",
    label: "Galería 12",
    alt: "Daniel Montana en una fotografía de galería",
    src: "/gallery/29B46DCA-B633-4CB6-9913-4A81D612CE40.jpeg",
    category: "Lifestyle",
    ratio: "landscape",
    tone: "olive",
    rating: "public",
  },
  {
    id: "13",
    label: "Galería 13",
    alt: "Daniel Montana en una fotografía de galería",
    src: "/gallery/C90F650E-AE2D-4BF8-9E63-2292694A7C6F.jpeg",
    category: "Lifestyle",
    ratio: "portrait",
    tone: "wine",
    rating: "public",
  },
  {
    id: "14",
    label: "Galería 14",
    alt: "Daniel Montana en una fotografía de galería",
    src: "/gallery/B92496A4-56AC-42FB-8E67-8980B161F136.jpeg",
    category: "Portrait",
    ratio: "portrait",
    tone: "smoke",
    rating: "public",
  },
  {
    id: "15",
    label: "Galería 15",
    alt: "Daniel Montana en una fotografía de galería",
    src: "/gallery/CA7BF3BA-A9E6-489E-83AC-AFF671AD65C9.jpeg",
    category: "Lifestyle",
    ratio: "portrait",
    tone: "sand",
    rating: "public",
  },
  {
    id: "16",
    label: "Galería 16",
    alt: "Daniel Montana en una fotografía de galería",
    src: "/gallery/8FAA4DC8-A58F-4A53-B4EE-6EF10DFCF3F0.jpeg",
    category: "Portrait",
    ratio: "portrait",
    tone: "olive",
    rating: "public",
  },
  {
    id: "17",
    label: "Galería 17",
    alt: "Daniel Montana en una fotografía de galería",
    src: "/gallery/164A4FBC-B2EC-4ADB-B9B8-C4D36070FC84.jpeg",
    category: "Lifestyle",
    ratio: "portrait",
    tone: "wine",
    rating: "public",
  },
  {
    id: "18",
    label: "Galería 18",
    alt: "Daniel Montana en una fotografía de galería",
    src: "/gallery/C776D6E6-7FF3-4DE4-907D-A6D493CEBBB2.jpeg",
    category: "Portrait",
    ratio: "portrait",
    tone: "smoke",
    rating: "public",
  },
  {
    id: "19",
    label: "Galería 19",
    alt: "Daniel Montana en una fotografía de galería",
    src: "/gallery/5AF1CC90-1C1C-4141-A4E1-94BE958EDD62.jpeg",
    category: "Fitness",
    ratio: "portrait",
    tone: "sand",
    rating: "public",
  },
  {
    id: "20",
    label: "Galería 20",
    alt: "Daniel Montana en una fotografía de galería",
    src: "/gallery/88D3C679-6E52-4737-A13F-93B92699C77D.jpeg",
    category: "Portrait",
    ratio: "portrait",
    tone: "olive",
    rating: "public",
  },
];

// Para contenido restricted, usa únicamente un preview público preparado:
// {
//   id: '09', label: 'Preview exclusivo', alt: 'Preview de contenido exclusivo de Daniel Montana',
//   previewSrc: '/gallery/exclusive-preview.webp', exclusiveUrl: 'https://…',
//   category: 'Editorial', ratio: 'portrait', tone: 'wine', rating: 'restricted',
// }

export const aboutPhoto = {
  /** Ruta pública, por ejemplo: /about/daniel-natural.webp */
  src: "/gallery/FFB6CBB8-5CBA-4127-A3CF-C8B4C6EDC0B3.jpeg",
  alt: "Daniel Montana en una fotografía lifestyle",
};

export const socialLinks = (locale: SiteLocale): LinkItem[] => [
  {
    label: localizedCopy[locale].telegramFree,
    iconSrc: "/logos/telegram-logo.svg",
    href: siteConfig.telegramFreeUrl,
    event: "telegram_free_click",
    analytics: { location: "social_section", destination: "telegram", button_text: localizedCopy[locale].telegramFree },
  },
  {
    label: "X",
    iconSrc: "/logos/x-logo.svg",
    href: siteConfig.xUrl,
    event: "x_click",
    analytics: { location: "social_section", destination: "x", button_text: "X" },
  },
  {
    label: "Instagram",
    iconSrc: "/logos/instagram-log.svg",
    href: siteConfig.instagramUrl,
    event: "instagram_click",
    analytics: { location: "social_section", destination: "instagram", button_text: "Instagram" },
  },
  {
    label: "Facebook",
    iconSrc: "/logos/facebook-logo.png",
    href: siteConfig.facebookUrl,
    event: "facebook_click",
    analytics: { location: "social_section", destination: "facebook", button_text: "Facebook" },
  },
  {
    label: "Threads",
    iconSrc: "/logos/threads-logo.svg",
    href: siteConfig.threadsUrl,
    event: "threads_click",
    analytics: { location: "social_section", destination: "threads", button_text: "Threads" },
  },
];

export const contactLink = (locale: SiteLocale): LinkItem => ({
  label: localizedCopy[locale].contact,
  description: "Colaboraciones, campañas y proyectos",
  href: siteConfig.contactEmail
    ? `mailto:${siteConfig.contactEmail}`
    : undefined,
  event: "contact_click",
  analytics: { location: "contact", destination: "email", button_text: localizedCopy[locale].contact },
});
